export default [
  {
    minScore: '50',
    maxScore: '52',
  },
  {
    minScore: '53',
    maxScore: '54',
  },
  {
    minScore: '55',
    maxScore: '57',
  },
  {
    minScore: '58',
    maxScore: '59',
  },
  {
    minScore: '60',
    maxScore: '62',
  },
  {
    minScore: '63',
    maxScore: '64',
  },
  {
    minScore: '65',
    maxScore: '66',
  },
  {
    minScore: '67',
    maxScore: '69',
  },
  {
    minScore: '70',
    maxScore: '71',
  },
  {
    minScore: '72',
    maxScore: '74',
  },
  {
    minScore: '75',
    maxScore: '76',
  },
  {
    minScore: '77',
    maxScore: '79',
  },
  {
    minScore: '80',
    maxScore: '81',
  },
  {
    minScore: '82',
    maxScore: '83',
  },
  {
    minScore: '84',
    maxScore: '86',
  },
  {
    minScore: '87',
    maxScore: '88',
  },
  {
    minScore: '89',
    maxScore: '91',
  },
  {
    minScore: '92',
    maxScore: '93',
  },
  {
    minScore: '94',
    maxScore: '96',
  },
  {
    minScore: '97',
    maxScore: '98',
  },
  {
    minScore: '99',
    maxScore: '100',
  },
  {
    minScore: '101',
    maxScore: '103',
  },
  {
    minScore: '104',
    maxScore: '105',
  },
  {
    minScore: '106',
    maxScore: '108',
  },
  {
    minScore: '109',
    maxScore: '110',
  },
  {
    minScore: '111',
    maxScore: '113',
  },
  {
    minScore: '114',
    maxScore: '115',
  },
  {
    minScore: '116',
    maxScore: '118',
  },
  {
    minScore: '119',
    maxScore: '120',
  },
  {
    minScore: '121',
    maxScore: '123',
  },
  {
    minScore: '124',
    maxScore: '125',
  },
  {
    minScore: '126',
    maxScore: '128',
  },
  {
    minScore: '129',
    maxScore: '130',
  },
  {
    minScore: '131',
    maxScore: '133',
  },
  {
    minScore: '134',
    maxScore: '135',
  },
  {
    minScore: '136',
    maxScore: '138',
  },
  {
    minScore: '139',
    maxScore: '140',
  },
  {
    minScore: '141',
    maxScore: '143',
  },
  {
    minScore: '144',
    maxScore: '145',
  },
  {
    minScore: '146',
    maxScore: '148',
  },
  {
    minScore: '149',
    maxScore: '150',
  },
]
